import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

const DEFAULT_CONSOLE_HOST = "console.jumpcloud.com";
const consoleHost = (configuredHost: string | undefined) =>
  configuredHost || DEFAULT_CONSOLE_HOST;

export const jumpCloud = defineConnector({
  identifier: "jumpCloud",
  name: "JumpCloud",
  tagLine: "Cloud directory platform",
  logo,
  protocol: "http",
  tags: ["it", "security", "identity"],
  defaultUrlPattern: ({ consoleHost: configuredHost }) =>
    domainToRegex(consoleHost(configuredHost)),
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Choose your JumpCloud region",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: DEFAULT_CONSOLE_HOST,
          target: { kind: "configuration", field: "consoleHost" },
          options: [
            { value: DEFAULT_CONSOLE_HOST, label: "United States" },
            { value: "console.eu.jumpcloud.com", label: "European Union" },
            { value: "console.in.jumpcloud.com", label: "India" },
          ],
          helperText:
            "The region where your JumpCloud organization’s data is stored.",
        },
      ],
    },
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into the JumpCloud Admin Portal for your organization’s region. Click your account name in the bottom left, then select **My API Key**.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "JumpCloud API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ consoleHost: configuredHost }) =>
      `https://${consoleHost(configuredHost)}/api/organizations`,
  },
});
